import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Form, Button, NavDropdown } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { categoryApi } from '../services/api';

const Header: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 카테고리 데이터 로드
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const categoriesData = await categoryApi.getCategories();
        setCategories(categoriesData);
      } catch (error) {
        console.error('카테고리 로드 실패:', error);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  // 카테고리별 아이콘 반환 함수
  const getCategoryIcon = (categoryName: string): string => {
    const iconMap: { [key: string]: string } = {
      '경제': 'fa-chart-line',
      '자연': 'fa-leaf',
      '스포츠': 'fa-futbol',
      '엔터테인먼트': 'fa-film',
      '기술': 'fa-microchip',
      '건강': 'fa-heartbeat',
      '교육': 'fa-graduation-cap',
      '여행': 'fa-plane',
      '음식': 'fa-utensils',
      '패션': 'fa-tshirt',
      '자동차': 'fa-car',
      '부동산': 'fa-home',
      '정치': 'fa-landmark',
      '사회': 'fa-users',
      '문화': 'fa-theater-masks',
      '과학': 'fa-flask',
      '역사': 'fa-book',
      '예술': 'fa-palette',
      '음악': 'fa-music',
      '게임': 'fa-gamepad'
    };
    
    return iconMap[categoryName] || 'fa-folder';
  };

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <Navbar 
      expand="lg" 
      className="theme-navbar shadow-sm sticky-top"
      variant="light"
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center fw-bold text-decoration-none">
          <i className="fas fa-chart-line me-2 text-primary"></i>
          <span className="gradient-text">차트 순위</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className="fw-semibold custom-nav-link">
              <i className="fas fa-home me-1" style={{ color: '#4f8cff', fontSize: '0.9em' }}></i>
              홈
            </Nav.Link>
            <NavDropdown 
              title={
                <span className="fw-semibold custom-nav-link">
                  <i className="fas fa-tags me-1" style={{ color: '#4f8cff', fontSize: '0.9em' }}></i>
                  카테고리
                </span>
              } 
              id="basic-nav-dropdown"
              className="fw-semibold"
            >
              {loading ? (
                <NavDropdown.Item disabled>
                  <i className="fas fa-spinner fa-spin me-2"></i>
                  로딩 중...
                </NavDropdown.Item>
              ) : (
                categories.map((category) => (
                  <NavDropdown.Item 
                    key={category.id} 
                    as={Link} 
                    to={`/category/${category.name}`}
                    className="d-flex align-items-center"
                  >
                    <i 
                      className={`fas ${getCategoryIcon(category.name)} me-2`} 
                      style={{ color: category.color || '#6c757d' }}
                    ></i>
                    {category.name}
                    {category.chart_count > 0 && (
                      <span className="badge bg-secondary ms-auto">{category.chart_count}</span>
                    )}
                  </NavDropdown.Item>
                ))
              )}
            </NavDropdown>
          </Nav>
          
          <div className="d-flex align-items-center gap-3">
            <Form className="d-flex" onSubmit={handleSearch}>
              <Form.Control
                type="search"
                placeholder="차트 검색..."
                className="me-2 border-0 shadow-sm"
                aria-label="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  backgroundColor: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  borderRadius: '20px',
                  paddingLeft: '15px',
                  paddingRight: '15px'
                }}
              />
              <Button 
                variant="outline-primary" 
                type="submit"
                className="rounded-circle"
                style={{ width: '40px', height: '40px' }}
              >
                <i className="fas fa-search"></i>
              </Button>
            </Form>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header; 